import { render, staticRenderFns } from "./TermsAndConditionsPage.vue?vue&type=template&id=edd38a88&scoped=true&"
import script from "./TermsAndConditionsPage.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsPage.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsPage.vue?vue&type=style&index=0&id=edd38a88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd38a88",
  null
  
)

export default component.exports